// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eWjXh","col":"styles_col__3H5NP"};